import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

/**
 * Sends failed API calls to Datadog so they show up in Error Tracking.
 *
 * When a request fails we report the endpoint and status to RUM
 */
export const rumErrorMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const endpoint = (action.meta.arg as { endpointName?: string })?.endpointName ?? 'unknown';
    const status = (action.payload as FetchBaseQueryError | undefined)?.status ?? 'unknown';

    void import('@datadog/browser-rum')
      .then(({ datadogRum }) => {
        datadogRum.addError(new Error(`Endpoint request failed: ${endpoint} (${status})`), {
          scope: 'api',
          endpoint,
          status,
        });
      })
      .catch(() => {
        // telemetry should never break the app
      });

    void import('@datadog/browser-logs')
      .then(({ datadogLogs }) => {
        datadogLogs.logger.error(`Endpoint request failed: ${endpoint} (${status})`, {
          scope: 'api',
          endpoint,
          status,
        });
      })
      .catch(() => {
        // telemetry should never break the app
      });
  }

  return next(action);
};
